// BlockNote document REST helpers (solo-mode autosave).

import { api } from "@/api/client";


export interface BlockNoteDocument {
  document_id: string;
  document_kind: string;
  title?: string | null;
  blocks_json: unknown;
  blocks_text: string;
  version: number;
  created_at?: string | null;
  updated_at?: string | null;
}


export interface CreateDocumentInput {
  document_kind: string;
  text?: string | null;
  blocks_json?: unknown;
  title?: string | null;
}


export interface UpdateDocumentInput {
  blocks_json?: unknown;
  blocks_text?: string;
}


export function createDocument(
  input: CreateDocumentInput,
): Promise<BlockNoteDocument> {
  return api.post<BlockNoteDocument>("/api/v1/documents/", input);
}


export function fetchDocument(
  documentId: string,
  opts?: { signal?: AbortSignal },
): Promise<BlockNoteDocument> {
  return api.get<BlockNoteDocument>(
    `/api/v1/documents/${encodeURIComponent(documentId)}`,
    opts,
  );
}


export function updateDocument(
  documentId: string,
  input: UpdateDocumentInput,
): Promise<BlockNoteDocument> {
  return api.patch<BlockNoteDocument>(
    `/api/v1/documents/${encodeURIComponent(documentId)}`,
    input,
  );
}
